/** Values of a channel in its unit (data * scale), delta encoding resolved; null stays null. */
export function decodeChannel(channel) {
    let previous = null;
    return channel.data.map((raw) => {
        if (raw === null)
            return null;
        const absolute = channel.enc === "delta" && previous !== null ? previous + raw : raw;
        previous = absolute;
        return round(absolute * channel.scale);
    });
}
/** Time of sample i in ms from the start of the curve. */
export const sampleTime = (channel, i) => (channel.t0 ?? 0) + i * channel.dt;
/** Integer series from values in the channel's unit (rounded to the scale). */
export function encodeChannel(values, channel) {
    let previous = null;
    const data = values.map((v) => {
        if (v === null)
            return null;
        const absolute = Math.round(v / channel.scale);
        const out = channel.enc === "delta" && previous !== null ? absolute - previous : absolute;
        previous = absolute;
        return out;
    });
    return { ...channel, data };
}
const round = (x) => Math.round(x * 1e6) / 1e6; // 0.1 * 3 -> 0.3, not 0.30000000000000004
//# sourceMappingURL=curve.js.map